import { useTranslation } from 'react-i18next';
import type { Event } from '@/types';
import { EventCard } from './EventCard';

interface EventListProps {
  events: Event[];
  showYear?: boolean;
}

export function EventList({ events, showYear = true }: EventListProps) {
  const { t } = useTranslation('public');
  if (events.length === 0) {
    return (
      <p className="m-0 py-8 text-sm text-ink-2">{t('events.empty')}</p>
    );
  }

  return (
    <div>
      {events.map((event) => (
        <EventCard key={event.id} event={event} showYear={showYear} />
      ))}
    </div>
  );
}
